import { useBrand } from '../context/BrandContext';
import FastestFormLogin from './fastestform/Login';
import AbleLogin from './able/Login';

export default function Login() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleLogin /> : <FastestFormLogin />;
}
